/** @format */

import React, { useState } from 'react'
import { _$, Card } from '@king-design/react'
import styled from 'styled-components'
import CustomPageContainer from 'src/components/CustomPageContainer'
import HeaderFilter from '../components/HeaderFilter'
import Overview from './container/Overview'
import ChartRow from './container/ChartRow'
import ServiceList from './container/ServiceList'
import { ServiceOverviewSearchProps } from '../components/typescript'
import useNavRegion from 'src/hooks/useNavRegion'
import { initSearch, DEFAULT_HEADER_FILTER_RANGE } from '../components/constant'
// 嵌入页面隐藏面包屑
const IS_TOP_WINDOW = window.self === window.top
const ServiceOverview: React.FC<{ className?: string }> = ({ className }) => {
  const [filterSearch, setFilterSearch] = useState<ServiceOverviewSearchProps>(initSearch())
  const [quickKey, setQuickKey] = useState<string>(DEFAULT_HEADER_FILTER_RANGE)
  // 控制台region
  const region = useNavRegion()
  return (
    <div className={className}>
      <CustomPageContainer title={_$('服务总览')} showHeader={IS_TOP_WINDOW}>
        <Card type="none">
          <HeaderFilter
            value={filterSearch}
            quickKey={quickKey}
            showAggregate={true}
            onChange={(value, range) => {
              setQuickKey(range)
              setFilterSearch(value)
            }}
          />
          <Overview
            region={region}
            startTime={filterSearch?.time?.[0]}
            endTime={filterSearch?.time?.[1]}
          />
          <ChartRow
            region={region}
            startTime={filterSearch?.time?.[0]}
            endTime={filterSearch?.time?.[1]}
            aggregate={filterSearch?.aggregateType}
          />
          <ServiceList
            region={region}
            quickKey={quickKey}
            startTime={filterSearch?.time?.[0]}
            endTime={filterSearch?.time?.[1]}
          />
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(ServiceOverview)``
